import React from 'react'
import naturalStoneMainBgImg from '../../../assets/img/banner-natural-stone/natural-stone-base-background.jpg'
import LocalizedLink from '../../global/LocalizedLink'
import Translation from '../../global/Translation'
import { getLanguageDir } from '../../../store/ui/reducers'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'

const BannerLongCatalogNaturalStone = ({languageDir}) => {
    return (
        <div
            className="banner-long-catalog-natural-stone"
            style={{
                backgroundImage: `url(${naturalStoneMainBgImg})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: '50% 70%',
                height: '100%',
                width: '100%'
            }}
        >
            <div className="banner-overlay"></div>
            <div className="banner-content">
                <div className="text-column">
                    <h2>
                        <Translation id="new_natural_stone_section" defaultMessage="New Natural Stone section" />
                    </h2>
                </div>

                <div className="text-column">
                    <p>
                        <Translation id="explore_new_materials_new_section_natural_stone" defaultMessage="Explore the new materials available, advanced filter by stone type (quartzite, marble, granite, etc.), detailed technical information, and recommended uses. See also our outlet tables with special prices." />
                    </p>
                </div>

                <div className="button-column">
                    <LocalizedLink routeId="ROUTE_NATURAL_STONE" queryString="">
                        <button gtm-label="extended_banner--product-list_got-to-natural-stone">
                            <Translation id="access" defaultMessage="Access" />
                            <i class={languageDir === 'rtl' ? "fa fa-long-arrow-left" : "fa fa-long-arrow-right"} aria-hidden="true" />
                        </button>
                    </LocalizedLink>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        languageDir: getLanguageDir(state)
    }
}

export default injectIntl(connect(mapStateToProps, null)(BannerLongCatalogNaturalStone))
